import { createSelector } from 'reselect';
import _get from 'lodash/get';

export const newHistorySelector = state => state.newHistory;

export const historyBookingFilterSelector = createSelector(
  newHistorySelector,
  history => history.historyBookingFilter,
);

export const historyDeliveriesV2Selector = createSelector(
  newHistorySelector,
  history => _get(history, 'historyDeliveriesV2'),
);

export const ongoingBookingSelectionSelector = createSelector(
  newHistorySelector,
  history => history.ongoingBookingSelection,
);

export const historyBookingSelectionSelector = createSelector(
  newHistorySelector,
  history => history.historyBookingSelection,
);

export const ongoingBookingFilterSelector = createSelector(
  newHistorySelector,
  history => _get(history, 'ongoingBookingFilter', {}),
);

export const ongoingDeliveriesV2Selector = createSelector(
  newHistorySelector,
  history => _get(history, 'ongoingDeliveriesV2', []),
);

export const ongoingIntervalIdSelector = createSelector(
  newHistorySelector,
  history => _get(history, 'ongoingIntervalId'),
);

export const waybillSelector = createSelector(newHistorySelector, history =>
  _get(history, 'waybill', {}),
);

export const bookAgainSelector = createSelector(newHistorySelector, history =>
  _get(history, 'bookAgain'),
);
